import { FC, useEffect } from 'react'

// Strip any country segment from the App Store URL. The configured value is
// .../pk/app/..., which pins the Pakistan storefront and can dead-end a scan
// from a region with different availability; Apple sends a countryless link to
// the scanner's own storefront. Normalised here so it holds whatever the env
// var says.
export const IOS_APP_URL = (
  process.env.REACT_APP_IOS_APP_URL || 'https://apps.apple.com/app/id6743770339'
).replace(/(apps\.apple\.com)\/[a-z]{2}\//i, '$1/')
export const ANDROID_APP_URL = process.env.REACT_APP_ANDROID_APP_URL || 'https://play.google.com/store/apps/details?id=com.b4igo'
export const LANDING_PAGE = process.env.REACT_APP_B4IGO_LANDING_PAGE || 'https://www.b4igo.ai'

// What the QR code encodes. A QR is scanned by a *different* device, so
// localhost:3011 is unreachable to it — fall back to prod when running locally
// so the code is still scannable while developing. Every deployed environment
// serves this app from its own portal host (dev-portal.b4igo.us,
// qa-portal.b4igo.us, portal.b4igo.ai), so its own origin is already correct
// and needs no env var to stay that way.
// This is the portal, not REACT_APP_B4IGO_LANDING_PAGE: /download is a route in
// this app, and the landing site is a separate deployment.
const isLocalhost = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname)
export const DOWNLOAD_URL = `${isLocalhost ? 'https://portal.b4igo.ai' : window.location.origin}/download`

// The single QR code (print and in-app) points here, so this is the only thing
// deciding where a scan lands. Desktop falls through to the landing page.
// ponytail: iPadOS 13+ reports as "Macintosh" and lands on the landing page
// rather than the App Store — add a navigator.maxTouchPoints > 1 check if
// iPad installs matter.
export const storeUrlFor = (userAgent: string): string => {
  if (/android/i.test(userAgent)) return ANDROID_APP_URL
  if (/iPad|iPhone|iPod/.test(userAgent)) return IOS_APP_URL
  return LANDING_PAGE
}

const DownloadRedirect: FC = () => {
  useEffect(() => {
    window.location.href = storeUrlFor(navigator.userAgent || navigator.vendor)
  }, [])

  return (
    <div className='d-flex justify-content-center align-items-center vh-100'>
      <div className='text-center'>
        <div className='spinner-border text-primary mb-3' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
        <p>Redirecting to app store...</p>
      </div>
    </div>
  )
}

export default DownloadRedirect
